export default __webpack_public_path__ + "static/media/Geography01_02.ad634cfe.png";